const HEADER_OFFSET_BUFFER = 24; // extra px so success message sits fully below header
const SCROLL_DEFER_MS = 150; // after hash scroll to #contact_form

const scrollToContactSuccess = () => {
  const el = document.getElementById('contact-form-success');
  if (!el) return;

  // Use the visible header bar (grid container) so offset matches what covers the content
  const header =
    document.querySelector('[data-header-container]') ||
    document.querySelector('.shopify-section-group-header-group') ||
    document.querySelector('header');
  const headerHeight = header ? header.offsetHeight : 0;
  const top =
    el.getBoundingClientRect().top +
    window.scrollY -
    headerHeight -
    HEADER_OFFSET_BUFFER;

  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
};

const initContactFormSuccess = () => {
  const el = document.getElementById('contact-form-success');
  if (!el) return;

  // Run after browser's hash scroll to #contact_form so success message (above form) is scrolled into view
  setTimeout(scrollToContactSuccess, SCROLL_DEFER_MS);
};

export default initContactFormSuccess;
